import {
  getConfirmPatientHasNoAllergyEndPoint,
  getMediaFileEndpoint,
  getPatientsListEndpoint,
  getUnConfirmPatientHasNoAllergyEndPoint,
  methods,
  setMediaFileTagsEndpoint,
} from '../../utils/apiHelper'
import { transformUIToBackendStatus } from '../../pages/patient-chart-page/Utils'
import { apiCall } from '../../utils/restclient'
import {
  ADD_ALERT,
  ADD_ALERT_ERROR,
  ADD_ALERT_SUCCESS,
  ADD_ALLERGY,
  ADD_ALLERGY_ERROR,
  ADD_ALLERGY_SUCCESS,
  ADD_MEDIA_FILE,
  ADD_MEDIA_FILE_ERROR,
  ADD_MEDIA_FILE_SUCCESS,
  DELETE_MEDIA_FILE,
  DELETE_MEDIA_FILE_ERROR,
  DELETE_MEDIA_FILE_SUCCESS,
  CREATE_UPCOMING_VISIT_REMARK,
  CREATE_UPCOMING_VISIT_REMARK_ERROR,
  CREATE_UPCOMING_VISIT_REMARK_SUCCESS,
  DELETE_ALERT,
  DELETE_ALERT_ERROR,
  DELETE_ALERT_SUCCESS,
  DELETE_ALLERGY,
  DELETE_ALLERGY_ERROR,
  DELETE_ALLERGY_SUCCESS,
  EDIT_ALERT,
  EDIT_ALERT_ERROR,
  EDIT_ALERT_SUCCESS,
  GET_ALERTS_LIST,
  GET_ALERTS_LIST_ERROR,
  GET_ALERTS_LIST_SUCCESS,
  GET_AUDI_LOGS,
  GET_GET_AUDI_LOGS_ERROR,
  GET_GET_AUDI_LOGS_SUCCESS,
  GET_INTAKE_FORM,
  GET_INTAKE_FORM_ERROR,
  GET_INTAKE_FORM_SUCCESS,
  GET_INTAKE_FORMS,
  GET_INTAKE_FORMS_ERROR,
  GET_INTAKE_FORMS_SUCCESS,
  GET_MEDIA_FILES,
  GET_MEDIA_FILES_ERROR,
  GET_MEDIA_FILES_SUCCESS,
  GET_PATIENT_CHART_PRINTED_VERSION,
  GET_PATIENT_CHART_PRINTED_VERSION_ERROR,
  GET_PATIENT_CHART_PRINTED_VERSION_SUCCESS,
  GET_PATIENT_INFO,
  GET_PATIENT_INFO_ERROR,
  GET_PATIENT_INFO_SUCCESS,
  GET_PATIENT_PAST_VISITS,
  GET_PATIENT_PAST_VISITS_ERROR,
  GET_PATIENT_PAST_VISITS_SUCCESS,
  GET_PATIENT_UPCOMING_VISITS,
  GET_PATIENT_UPCOMING_VISITS_ERROR,
  GET_PATIENT_UPCOMING_VISITS_SUCCESS,
  GET_PATIENTS_LIST,
  GET_PATIENTS_LIST_ERROR,
  GET_PATIENTS_LIST_SUCCESS,
  GET_PRESCRIPTIONS,
  GET_RESCRIPTIONS_ERROR,
  GET_RESCRIPTIONS_SUCCESS,
  GET_UPCOMING_VISIT_REMARKS,
  GET_UPCOMING_VISIT_REMARKS_ERROR,
  GET_UPCOMING_VISIT_REMARKS_SUCCESS,
  MARK_ALERTS_AS_READ,
  MARK_ALERTS_AS_READ_ERROR,
  MARK_ALERTS_AS_READ_SUCCESS,
  REMOVE_UPCOMING_VISIT_REMARK,
  REMOVE_UPCOMING_VISIT_REMARK_ERROR,
  REMOVE_UPCOMING_VISIT_REMARK_SUCCESS,
  SEARCH_PHARMACIES,
  SEARCH_PHARMACIES_ERROR,
  SEARCH_PHARMACIES_SUCCESS,
  SET_MEDIA_FILE_TAGS,
  SET_MEDIA_FILE_TAGS_ERROR,
  SET_MEDIA_FILE_TAGS_SUCCESS,
  SET_ON_HOLD_STATUS,
  SET_ON_HOLD_STATUS_ERROR,
  SET_ON_HOLD_STATUS_SUCCESS,
  SET_PATIENT_HAS_ALLERGIES,
  SET_PATIENT_HAS_ALLERGIES_ERROR,
  SET_PATIENT_HAS_ALLERGIES_SUCCESS,
  SET_PATIENT_HAS_NO_ALLERGIES,
  SET_PATIENT_HAS_NO_ALLERGIES_ERROR,
  SET_PATIENT_HAS_NO_ALLERGIES_SUCCESS,
  UPDATE_ACCOUNT_INFO,
  UPDATE_ACCOUNT_INFO_ERROR,
  UPDATE_ACCOUNT_INFO_SUCCESS,
  UPDATE_GENERAL_INFO,
  UPDATE_GENERAL_INFO_ERROR,
  UPDATE_GENERAL_INFO_SUCCESS,
  UPDATE_UPCOMING_VISIT_REMARK,
  UPDATE_UPCOMING_VISIT_REMARK_ERROR,
  UPDATE_UPCOMING_VISIT_REMARK_SUCCESS,
  UPDATE_VISIT_CREDIT,
  UPDATE_VISIT_CREDIT_ERROR,
  UPDATE_VISIT_CREDIT_SUCCESS,
  VALIDATE_PHONE_NUMBER,
  VALIDATE_PHONE_NUMBER_ERROR,
  VALIDATE_PHONE_NUMBER_SUCCESS,
  SET_ON_HOLD_STATUS_WITH_REASON,
  SET_ON_HOLD_STATUS_WITH_REASON_SUCCESS,
  SET_ON_HOLD_STATUS_WITH_REASON_ERROR,
} from './ChartsConstants'

export const getChartPatientsList = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  offSet,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  count,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  searchStringCondition,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isUpdatePatientsList,
  birthDate = '',
}) => {
  const encodedSearchValue = encodeURIComponent(searchStringCondition).replace(
    /[!'()*]/g,
    (c) => `%${c.charCodeAt(0).toString(16)}`,
  )

  const endpoint = getPatientsListEndpoint({ count, offSet, encodedSearchValue, birthDate })
  const action = {
    type: GET_PATIENTS_LIST,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, methods.GET, null, null, {
      success: GET_PATIENTS_LIST_SUCCESS,
      error: GET_PATIENTS_LIST_ERROR,
      extraData: { isUpdatePatientsList },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getPatientPrescriptions = (patientId) => {
  const endpoint = `api/v1/patients/${patientId}/prescriptions`
  const action = {
    type: GET_PRESCRIPTIONS,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_RESCRIPTIONS_SUCCESS,
      error: GET_RESCRIPTIONS_ERROR,
      extraData: { patientId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getPatientAuditLogs = (patientId, logType) => {
  const COUNT = 300

  const endpoint = `api/v1/patients/${patientId}/logs/audit?Count=${COUNT}${logType ? `&LogType=${logType}` : ''}`

  const action = {
    type: GET_AUDI_LOGS,
  }

  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_GET_AUDI_LOGS_SUCCESS,
      error: GET_GET_AUDI_LOGS_ERROR,
      extraData: { patientId },
    })
    return action
  } catch (e) {
    console.error(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getPatientInfo = (patientId, mediaFiles) => {
  const endpoint = `api/v1/patients/${patientId}`
  const action = {
    type: GET_PATIENT_INFO,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_PATIENT_INFO_SUCCESS,
      error: GET_PATIENT_INFO_ERROR,
      extraData: { patientId, mediaFiles },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getPatientChartPrintedVersion = (patientId) => {
  const endpoint = `api/v1/patients/${patientId}/report`
  const action = {
    type: GET_PATIENT_CHART_PRINTED_VERSION,
    extra: { patientId },
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_PATIENT_CHART_PRINTED_VERSION_SUCCESS,
      error: GET_PATIENT_CHART_PRINTED_VERSION_ERROR,
      extraData: { patientId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const getIntakeForm = ({ patientId, intakeFormId }) => {
  const endpoint = `api/v1/patients/${patientId}/intakeforms/${intakeFormId}`
  const action = {
    type: GET_INTAKE_FORM,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_INTAKE_FORM_SUCCESS,
      error: GET_INTAKE_FORM_ERROR,
      extraData: { patientId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getPatientPastVisits = (patientId) => {
  const endpoint = `api/v1/patients/${patientId}/visits/past`
  const action = {
    type: GET_PATIENT_PAST_VISITS,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_PATIENT_PAST_VISITS_SUCCESS,
      error: GET_PATIENT_PAST_VISITS_ERROR,
      extraData: { patientId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getPatientUpcomingVisits = (patientId) => {
  const endpoint = `api/v1/patients/${patientId}/visits/upcoming`
  const action = {
    type: GET_PATIENT_UPCOMING_VISITS,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_PATIENT_UPCOMING_VISITS_SUCCESS,
      error: GET_PATIENT_UPCOMING_VISITS_ERROR,
      extraData: { patientId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const addAllergy = (patientId, allergy, tabId) => {
  const endpoint = `api/v1/patients/${patientId}/allergies`
  const action = {
    type: ADD_ALLERGY,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'POST', null, JSON.stringify(allergy), {
      success: ADD_ALLERGY_SUCCESS,
      error: ADD_ALLERGY_ERROR,
      extraData: { tabId, patientId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const deleteAllergy = (patientId, allergyId, tabId) => {
  const endpoint = `api/v1/patients/${patientId}/allergies/${allergyId}`
  const action = {
    type: DELETE_ALLERGY,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'DELETE', null, null, {
      success: DELETE_ALLERGY_SUCCESS,
      error: DELETE_ALLERGY_ERROR,
      extraData: { tabId, patientId, allergyId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getAlertsList = (patientId) => {
  const endpoint = `api/v1/patients/${patientId}/alerts`
  const action = {
    type: GET_ALERTS_LIST,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_ALERTS_LIST_SUCCESS,
      error: GET_ALERTS_LIST_ERROR,
      extraData: { patientId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setOnHoldStatus = (patientId, newStatus) => {
  const api = newStatus ? 'deactivate' : 'activate'
  const endpoint = `api/v1/patients/${patientId}/${api}`
  console.log('here', newStatus)
  const action = {
    type: SET_ON_HOLD_STATUS,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'PUT', null, null, {
      success: SET_ON_HOLD_STATUS_SUCCESS,
      error: SET_ON_HOLD_STATUS_ERROR,
      extraData: { patientId, newStatus },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setOnHoldStatusWithReason = (patientId, newStatus, reason) => {
  const backendStatus = transformUIToBackendStatus(newStatus)
  const endpoint = `api/v1/patients/${patientId}/restriction`
  const action = {
    type: SET_ON_HOLD_STATUS_WITH_REASON,
  }

  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, methods.PUT, null, JSON.stringify({ RestrictionStatus: backendStatus, Message: reason }), {
      success: SET_ON_HOLD_STATUS_WITH_REASON_SUCCESS,
      error: SET_ON_HOLD_STATUS_WITH_REASON_ERROR,
      extraData: { patientId, newStatus, reason },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const addAlert = (patientId, alert) => {
  const endpoint = `api/v1/patients/${patientId}/alerts`
  const action = {
    type: ADD_ALERT,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'POST', null, JSON.stringify(alert), {
      success: ADD_ALERT_SUCCESS,
      error: ADD_ALERT_ERROR,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const editAlert = (patientId, alert, alertId) => {
  const endpoint = `api/v1/patients/${patientId}/alerts/${alertId}`
  const action = {
    type: EDIT_ALERT,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'PUT', null, JSON.stringify(alert), {
      success: EDIT_ALERT_SUCCESS,
      error: EDIT_ALERT_ERROR,
      extraData: { patientId, alertId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const deleteAlert = (patientId, alertId) => {
  const endpoint = `api/v1/patients/${patientId}/alerts/${alertId}`
  const action = {
    type: DELETE_ALERT,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'DELETE', null, null, {
      success: DELETE_ALERT_SUCCESS,
      error: DELETE_ALERT_ERROR,
      extraData: { patientId, alertId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const markAlertsAsRead = (patientId) => {
  const endpoint = `api/v1/patients/${patientId}/alerts/markasread`
  const action = {
    type: MARK_ALERTS_AS_READ,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'PUT', null, null, {
      success: MARK_ALERTS_AS_READ_SUCCESS,
      error: MARK_ALERTS_AS_READ_ERROR,
      extraData: { patientId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const updateAccountInfo = ({ patientId, newAccountInfo, newPharmacyInfo, mediaFiles }) => {
  const endpoint = `api/v1/patients/${patientId}/accountinfo`
  const action = {
    type: UPDATE_ACCOUNT_INFO,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'PUT', null, JSON.stringify(newAccountInfo), {
      success: UPDATE_ACCOUNT_INFO_SUCCESS,
      error: UPDATE_ACCOUNT_INFO_ERROR,
      extraData: { isUpdateAccountInfoRequest: true, patientId, newAccountInfo, newPharmacyInfo, mediaFiles },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const updateGeneralInfo = (patientId, newGeneralInfo) => {
  const endpoint = `api/v1/patients/${patientId}/generalinfo`
  const action = {
    type: UPDATE_GENERAL_INFO,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'PUT', null, JSON.stringify(newGeneralInfo), {
      success: UPDATE_GENERAL_INFO_SUCCESS,
      error: UPDATE_GENERAL_INFO_ERROR,
      extraData: { patientId, newGeneralInfo },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const searchPharmacies = (patientId, searchValue) => {
  const endpoint = `api/v1/pharmacies?PatientId=${patientId}&Count=10&SearchValue=${searchValue}`
  const action = {
    type: SEARCH_PHARMACIES,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: SEARCH_PHARMACIES_SUCCESS,
      error: SEARCH_PHARMACIES_ERROR,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const updateVisitCredit = (patientId, newVisitCreditInfo) => {
  const endpoint = `api/v1/patients/${patientId}/credit`
  const action = {
    type: UPDATE_VISIT_CREDIT,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'PUT', null, JSON.stringify(newVisitCreditInfo), {
      success: UPDATE_VISIT_CREDIT_SUCCESS,
      error: UPDATE_VISIT_CREDIT_ERROR,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export function getMediaFiles({ patientId, mediaFiles }) {
  const endpoint = `api/v1/patients/${patientId}/mediafiles`
  const action = {
    type: GET_MEDIA_FILES,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_MEDIA_FILES_SUCCESS,
      error: GET_MEDIA_FILES_ERROR,
      extraData: { patientId, mediaFiles },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export function setMediaFileTags({ patientId, fileId, updateRequestBody }) {
  const endpoint = setMediaFileTagsEndpoint(patientId, fileId)
  const action = {
    type: SET_MEDIA_FILE_TAGS,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'PUT', null, JSON.stringify(updateRequestBody), {
      success: SET_MEDIA_FILE_TAGS_SUCCESS,
      error: SET_MEDIA_FILE_TAGS_ERROR,
      extraData: { patientId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const addMediaFile = ({ patientId, data }, mediaFiles, shouldRefresh = true) => {
  const endpoint = `api/v1/patients/${patientId}/mediafiles`
  const action = {
    type: ADD_MEDIA_FILE,
  }
  try {
    apiCall(
      endpoint,
      'POST',
      null,
      data,
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      {
        success: ADD_MEDIA_FILE_SUCCESS,
        error: ADD_MEDIA_FILE_ERROR,
        extraData: { patientId, mediaFiles, shouldRefresh },
      },
      null,
      {},
    )
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const deleteMediaFile = (patientId, fileId) => {
  const endpoint = getMediaFileEndpoint(patientId, fileId)
  const action = {
    type: DELETE_MEDIA_FILE,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'DELETE', null, null, {
      success: DELETE_MEDIA_FILE_SUCCESS,
      error: DELETE_MEDIA_FILE_ERROR,
      extraData: { patientId, fileId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function validatePhoneNumber(number, patientId) {
  const endpoint = `api/v1/utilities/validatephonenumber`
  const extraData = { patientId }
  const action = {
    type: VALIDATE_PHONE_NUMBER,
    extraData,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'POST', null, JSON.stringify(number), {
      success: VALIDATE_PHONE_NUMBER_SUCCESS,
      error: VALIDATE_PHONE_NUMBER_ERROR,
      extraData,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getIntakeForms = (patientId) => {
  const endpoint = `api/v1/patients/${patientId}/intakeforms`

  const action = {
    type: GET_INTAKE_FORMS,
  }

  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_INTAKE_FORMS_SUCCESS,
      error: GET_INTAKE_FORMS_ERROR,
      extraData: { patientId },
    })

    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setPatientHasNoAllergies = (patientId, tabId) => {
  const endpoint = getConfirmPatientHasNoAllergyEndPoint(patientId)
  const action = {
    type: SET_PATIENT_HAS_NO_ALLERGIES,
  }

  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, methods.PUT, null, null, {
      success: SET_PATIENT_HAS_NO_ALLERGIES_SUCCESS,
      error: SET_PATIENT_HAS_NO_ALLERGIES_ERROR,
      extraData: { patientId, tabId },
    })

    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setPatientHasAllergies = (patientId, tabId) => {
  const endpoint = getUnConfirmPatientHasNoAllergyEndPoint(patientId)
  const action = {
    type: SET_PATIENT_HAS_ALLERGIES,
  }

  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, methods.PUT, null, null, {
      success: SET_PATIENT_HAS_ALLERGIES_SUCCESS,
      error: SET_PATIENT_HAS_ALLERGIES_ERROR,
      extraData: { patientId, tabId },
    })

    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getUpcomingVisitRemarks = (visitId) => {
  const endpoint = `api/v1/visits/${visitId}/remarks`

  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_UPCOMING_VISIT_REMARKS_SUCCESS,
      error: GET_UPCOMING_VISIT_REMARKS_ERROR,
      extraData: { visitId },
    })

    return {
      type: GET_UPCOMING_VISIT_REMARKS,
    }
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const createUpcomingVisitRemark = ({ visitId, Message }) => {
  const endpoint = `api/v1/visits/${visitId}/remarks`
  const action = {
    type: CREATE_UPCOMING_VISIT_REMARK,
  }
  try {
    apiCall(
      endpoint,
      'POST',
      null,
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      JSON.stringify({ Message }),
      {
        success: CREATE_UPCOMING_VISIT_REMARK_SUCCESS,
        error: CREATE_UPCOMING_VISIT_REMARK_ERROR,
        extraData: { visitId },
      },
      null,
      null,
      0,
      false,
    )
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const updateUpcomingVisitRemark = ({ visitId, remarkId, Message }) => {
  const endpoint = `api/v1/visits/${visitId}/remarks/${remarkId}`
  const action = {
    type: UPDATE_UPCOMING_VISIT_REMARK,
  }
  try {
    apiCall(
      endpoint,
      'PUT',
      null,
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      JSON.stringify({ Message }),
      {
        success: UPDATE_UPCOMING_VISIT_REMARK_SUCCESS,
        error: UPDATE_UPCOMING_VISIT_REMARK_ERROR,
        extraData: { visitId, remarkId },
      },
      null,
      null,
      0,
      false,
    )
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const removeUpcomingVisitRemark = ({ visitId, remarkId }) => {
  const endpoint = `api/v1/visits/${visitId}/remarks/${remarkId}`
  const action = {
    type: REMOVE_UPCOMING_VISIT_REMARK,
  }
  try {
    apiCall(
      endpoint,
      'DELETE',
      null,
      null,
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      {
        success: REMOVE_UPCOMING_VISIT_REMARK_SUCCESS,
        error: REMOVE_UPCOMING_VISIT_REMARK_ERROR,
        extraData: { visitId, remarkId },
      },
      null,
      null,
      0,
      false,
    )
    return action
  } catch (e) {
    console.log(e)
  }
}
